import type { FC } from 'react';

export const FormattedBytes: FC<{ value?: number; decimals?: number }> = ({ value = 0, decimals = 2 }) => {
  if (value === 0) return <>&apos;0 Bytes&apos;</>;

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(value) / Math.log(k));

  return (
    <>
      {parseFloat((value / k ** i).toFixed(dm))} {sizes[i]}
    </>
  );
};
